export const DEFAULT_SUPPORT_URL =
  'https://onevest.zendesk.com/hc/en-us/requests/new';

export const ADVISOR_ENTITIES_COUNT_DELAY_THRESHOLD = 5000;
